import { FileEdit } from "lucide-react";
import { HERO_BADGE_TEXT, COURSE_SEATS } from "./kursusConstants";

const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });

export function MobileStickyCTA() {
  return (
    <div
      data-testid="kursus-mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-kursus-bg/95 backdrop-blur-md border-t border-kursus-gold/40 px-4 py-3 flex items-center justify-between gap-3"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="min-w-0">
        <p className="font-oswald text-xs font-bold text-kursus-gold tracking-wide">{HERO_BADGE_TEXT}</p>
        <p className="text-[10px] text-kursus-muted">{COURSE_SEATS} TEMPAT SAHAJA</p>
      </div>
      <button
        data-testid="kursus-mobile-sticky-cta-btn"
        onClick={() => scrollTo("#daftar")}
        className="flex items-center gap-1.5 bg-kursus-gold text-black font-oswald font-bold text-sm px-4 py-2.5 rounded-full shrink-0"
      >
        <FileEdit className="w-4 h-4" /> DAFTAR SEKARANG
      </button>
    </div>
  );
}
